import { EPromoType } from '../types/newbuilding/promos';

export const QUANTITY_PROMOS_IN_ROW = 3;

export const EXTRA_PROMO_TYPES = [EPromoType.CianMortgage];

export const MORTGAGE_PROMO_TYPES = [EPromoType.Mortgage, EPromoType.Bank, EPromoType.CianMortgage];
